<div class="post-wrapper">
  <div class="content">
    <div class="social-networks">
      <ng-container *ngIf="post.isFacebookPost">
        <img
          *ngIf="post.postToFacebook"
          src="assets/images/icons/ic_facebookContent.svg"
          alt="Facebook"
        />
        <img
          *ngIf="post.postToInstagram"
          class="instagram-icon"
          src="assets/images/icons/ic_instagramContent.svg"
          alt="Instagram"
        />
      </ng-container>
      <img
        *ngIf="post.isGoogleAd"
        src="assets/images/google-ad-logo.svg"
        alt="Google"
      />
      <img
        *ngIf="post.isLinkedInPost"
        class="linkedin-icon"
        src="assets/images/icons/linkedin/ic_linkedin.svg"
        alt="LinkedIn"
      />
    </div>
    <div *ngIf="post.isFacebookPost" class="media">
      <img
        *ngIf="post.image && post.isRenderedAsImage"
        class="post-image"
        src="{{ post.image }}"
        alt="post-image"
        loading="lazy"
      />

      <app-panoramic-viewer
        *ngIf="post.mediaType === CampaignPostContentType.Image360"
        [imageUrl]="post.image"
      />
      <app-carousel *ngIf="post.mediaType === CampaignPostContentType.Carousel">
        <div
          carouselItem
          *ngFor="let item of post.carouselSlides"
          [image]="resizeImage(item.url, item.imagePublicId)"
          [text]="item.title"
          [videoUrl]="item.videoUrl"
          [link]="post.link"
        ></div>
      </app-carousel>
      <ng-container *ngIf="post.mediaType === CampaignPostContentType.Video">
        <video
          *ngIf="post.videoUrl"
          style="width: 100%"
          src="{{ post.videoUrl }}"
          controls
          type="video/mp4; codecs=hvc1"
          preload="metadata"
        ></video>
        <img
          *ngIf="!post.videoUrl"
          class="post-image"
          src="{{ post.image }}"
          alt="post-image"
          loading="lazy"
        />
      </ng-container>
    </div>
    <p *ngIf="post.isFacebookPost" class="post-text">{{ post.text }}</p>

    <div class="google-ad" *ngIf="post.isGoogleAd">
      <div *ngIf="post.image" class="google-ad-image">
        <img [src]="post.image" alt="" loading="lazy" />
      </div>
      <div class="google-ad-title">{{ post.headlineOne }}</div>
      <div class="google-ad-content">
        <div class="google-ad-content-column google-ad-content-column--short">
          <div class="google-ad-content-logo">
            <img src="{{ getEmptyPartnerLogo() }}" loading="lazy" />
          </div>
        </div>
        <div
          class="google-ad-content-column google-ad-content-column--long google-ad-content-text"
        >
          <div>{{ post.descriptionOne }}</div>
          <div class="google-ad-subtitle">
            {{ post.partnerCompanyName }}
          </div>
        </div>
        <div class="google-ad-content-column google-ad-content-column--short">
          <div class="google-ad-content-icon">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="post.isLinkedInPost" class="media">
      <app-linkedin-multi-image-mock-up
        *ngIf="
          post.mediaType === LinkedInContentType.MultiImage ||
          post.mediaType === LinkedInContentType.Image
        "
        [post]="post"
      ></app-linkedin-multi-image-mock-up>
      <video
        *ngIf="post.mediaType === LinkedInContentType.Video"
        style="width: 100%"
        src="{{ post.videoUrl }}"
        controls
        type="video/mp4; codecs=hvc1"
        preload="metadata"
      ></video>
      <p class="post-text">{{ post.text }}</p>
    </div>
  </div>

  <div class="actions">
    <div class="left">
      <mat-icon
        *ngIf="isEditable"
        (click)="onDeletePostConfirm()"
        class="action delete"
        >delete</mat-icon
      >
      <img
        *ngIf="isEditable"
        (click)="onMoveCategoryConfirm()"
        class="action action--move"
        src="/assets/images/icons/ic_change_post_category.svg"
        width="16"
      />
    </div>
    <div class="right">
      <mat-icon
        *ngIf="isEditable && !post?.isReviewApproved"
        class="action"
        (click)="onEditPost()"
        >edit</mat-icon
      >
      <img
        class="action"
        (click)="onPreviewPost()"
        src="/assets/images/icons/ic_previewBlack.svg"
        alt="preview"
      />
      <ng-container *ngIf="campaign.isEditable">
        <img
          class="action comment"
          *ngIf="
            !isPendingReview() &&
            !post.areCommentsApproved &&
            !post?.isReviewApproved
          "
          (click)="onCommentPost()"
          src="/assets/images/icons/ic_comment-default.svg"
          matTooltip="{{
            'brand.campaign.content.approval.postComments' | translate
          }}"
        />
        <img
          class="action comment-warning"
          *ngIf="isPendingReview()"
          (click)="onCommentPost()"
          src="/assets/images/icons/ic_comment-warning.svg"
          matTooltip="{{
            'brand.campaign.content.approval.commentsNotResolved' | translate
          }}"
        />
        <img
          class="action comment-resolved"
          *ngIf="
            (post?.isReviewTextCommentResolved &&
              post?.isReviewImageCommentResolved) ||
            post?.isReviewApproved
          "
          src="/assets/images/icons/ic_comment-resolved.svg"
          (click)="onCommentPost()"
          matTooltip="{{
            'brand.campaign.content.approval.commentsResolved' | translate
          }}"
        />
        <img
          class="action"
          *ngIf="!post?.isReviewApproved"
          (click)="onApprovePost()"
          src="/assets/images/icons/ic_approval-default.svg"
          matTooltip="{{
            'brand.campaign.content.approval.approvePost' | translate
          }}"
        />
        <img
          class="action"
          *ngIf="post?.isReviewApproved"
          (click)="onDisapprovePost()"
          src="/assets/images/icons/ic_approval-active.svg"
          matTooltip="{{
            'brand.campaign.content.approval.approved'
              | translate: getApprovalUserData()
          }}"
        />
      </ng-container>
      <ng-container *ngIf="!campaign.isEditable">
        <img
          class="action disabled-action"
          src="/assets/images/icons/ic_comment-inactive.svg"
          matTooltip="{{
            'brand.campaign.content.approval.commentsNotAvailable' | translate
          }}"
        />
        <img
          class="action disabled-action"
          src="/assets/images/icons/ic_approval-active.svg"
          matTooltip="{{
            'brand.campaign.content.approval.approvalNotAvailable' | translate
          }}"
        />
      </ng-container>
    </div>
  </div>
</div>
